import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import {injectIntl} from 'react-intl'
import Tooltip from '@mui/material/Tooltip'
import {Create, FileCopy} from '@mui/icons-material'
import Loader from './Loader'
import {valueFormatter} from 'utils/utils'

const Img = styled.span`
    height: 100%;
    width: 100%;
    min-width: ${props => props.short ? '110px' : ''};
    max-height: ${props => props.small ? '100%' : '110px'};
    max-width: ${props => props.small ? '100%' : '110px'};
    background-position-x: ${props => props.small ? 'center' : 'left'};
    background-position-y: ${props => props.small ? 'center' : 'top'};
    background-repeat: no-repeat;
    background-size: contain;
    margin-left: ${props => props.small ? 0 : '-10px'};
    margin-top: ${props => props.small || props.short ? 0 : '-15px'};
`

const Info = styled.span`
    color: #7c9198;
    font-size: 12px;
    margin-top: auto;
`

const Name = styled.span`
    font-weight: 700;
    font-size: ${props => props.font}px;
    overflow: hidden;
    display: block;
    display: -webkit-box;
    line-height: 1.4;
    height: ${props => props.font * 1.4 * 2}px;
    margin-bottom: 5px;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`

const Value = styled.div`
    width: 100%;
    font-weight: 600;
    font-size: 36px;
    line-height: 1;
    margin-top: auto;
    white-space: nowrap;
`

const Hidden = styled.div`
    font-weight: 600;
    font-size: 36px;
    position: absolute;
    visibility: hidden;
    white-space: nowrap;
    opacity: 0;
`

const Col = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
`

const sx = {
	right: 0,
	top: 0,
	color: 'rgb(107, 107, 107)',
	fontSize: '16px',
	padding: '5px',
	position: 'absolute',
	background: 'rgba(255, 255, 255, 0.5)',
	borderRadius: '10px'
}

class SimpleCard extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            value: undefined
        }
    }

    componentDidMount() {
        if (this.props.widget) {
            this.props.getRollup(this.props.id)
            this.setState({loading: true})
        }
    }

    componentDidUpdate(props) {
        if (this.props.widget && this.props.rollupValue && this.state.loading) {
            const value = this.props.rollupValue.data.length && this.props.rollupValue.data[0].value ?
                valueFormatter(this.props.rollupValue.data[0].value, this.props.rollupValue.fieldValueId) : null

            if (this.state.value !== value) {
                this.setState({
                    loading: false,
                    value
                })
            }
        }

        if (this.props.widget && this.state.value && !this.state.loading) {
            this.setSize()
        }

        if (this.props.widget && this.props.updating === this.props.id &&
        this.props.name === props.name && this.props.icon === props.icon) {
            this.props.getRollup(this.props.id)
            this.setState({
                loading: true,
                value: undefined
            })
        }
    }

    handleClick = (e) => {
        e.stopPropagation()
        this.props.handleClick(this.props.type, this.props.id)
    }

    handleCopy = (e) => {
        e.stopPropagation()
        this.props.handleCopy(this.props.id)
    }

    setSize = () => {
        const defaultFontSize = 36
        const parentPadding = 40
        const ghost = document.querySelector(`[data-ghost-id='${this.props.id}']`)
        const value = document.querySelector(`[data-value-id='${this.props.id}']`)
        let fontSize = defaultFontSize
        ghost.style.fontSize = defaultFontSize + 'px'

        while (ghost.clientWidth > ghost.offsetParent.clientWidth - parentPadding) {
            fontSize--
            ghost.style.fontSize = fontSize + 'px'
        }

        value.style.fontSize = fontSize + 'px'
    }

    getDate = (ts) => {
        const { intl } = this.props
        const now = new Date()
        const time = moment(ts).format('HH:mm')
        const yesterday = moment(now).subtract(1, 'day')

        if (moment(now).diff(moment(ts)) < 300000) {
            return intl.formatMessage({id: "app.now"})
        } else if (moment(ts).isSame(moment(now), 'day')) {
            return intl.formatMessage({id: "app.today"}) + ', ' + time
        } else if (moment(ts).isSame(yesterday, 'day')) {
            return intl.formatMessage({id: "app.yesterday"}) + ', ' + time
        } else {
            return moment(ts).format('DD MMM, HH:mm')
        }
    }

    render() {
        const { intl, mobile, planning, widget, editable } = this.props

        return (
            <React.Fragment>
                {!mobile && this.props.isDesigner && !widget && editable &&
                    <Tooltip
                        title={intl.formatMessage({id: "app.duplicate"})}
                        placement="top"
                    >
                        <FileCopy sx={sx} style={!planning ? {right: '26px'} : {}}
                            onClick={this.handleCopy}
                        />
                    </Tooltip>
                }
                {!mobile && !planning && this.props.isDesigner && editable &&
                    <Tooltip
                        title={intl.formatMessage({id: "main.edit"})}
                        placement="top"
                    >
                        <Create sx={sx}
                            onClick={this.handleClick}
                        />
                    </Tooltip>
                }
                {widget && this.props.small ?
                    <React.Fragment /> :
                    <Img
                        className={"entity-icon-" + this.props.icon}
                        small={this.props.small}
                        short={this.props.short}
                    />
                }
                {!widget && this.props.small ?
                    <React.Fragment /> :
                    <Col>
                        {(widget || !this.props.small) &&
                            <Name font={!this.props.small && !this.props.short ? 16 : 16}>{this.props.name}</Name>
                        }
                        {widget ?
                            <React.Fragment>
                                {this.state.loading ?
                                    <Loader />
                                    :
                                    <React.Fragment>
                                        {this.state.value ?
                                            <React.Fragment>
                                                <Hidden data-ghost-id={this.props.id}>{this.state.value}</Hidden>
                                                <Value data-value-id={this.props.id}>{this.state.value}</Value>
                                            </React.Fragment>
                                            :
                                            <Value>{intl.formatMessage({id: "main.not_available"})}</Value>
                                        }
                                    </React.Fragment>
                                }
                            </React.Fragment>
                            :
                            <React.Fragment>
                                {!this.props.small && !planning && this.props.ts &&
                                    <Info>
                                        {intl.formatMessage({id: "main.last_edited"})}: {this.getDate(this.props.ts)}
                                    </Info>
                                }
                            </React.Fragment>
                        }
                    </Col>
                }
            </React.Fragment>
        )
    }
}

export default injectIntl(SimpleCard)
